import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface StaffEngagementRow {
	staffId: number;
	staffName: string;
	engagedCount: number;
	assignedCount: number;
}

@Component({
	selector: 'staff-engagement-counts',
	standalone: true,
	templateUrl: './staff-engagement-counts.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./staff-engagement-counts.widget.scss'],
})
export class StaffEngagementCountsWidget {

	@Input() data: StaffEngagementRow[] = [];

}
